export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 text-neutral-400 py-16 px-6 border-t border-neutral-800">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-6">
          <div className="text-3xl font-bold text-white tracking-tight">
            Alejandro Romanisio
          </div>
          <p className="text-lg text-neutral-300 max-w-2xl mx-auto leading-relaxed">
            Ayudando a profesionales a sentirse seguros trabajando con datos
          </p>
          <div className="pt-8 border-t border-neutral-800">
            <p className="text-sm text-neutral-500">
              {currentYear} Alejandro Romanisio. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
